// extracted by mini-css-extract-plugin
export default {"banner":"DeprecationBanner_banner__Q4eEC","content":"DeprecationBanner_content__yRjtZ","link":"DeprecationBanner_link__lr9Q3"};